import { render, staticRenderFns } from "./ChainList.vue?vue&type=template&id=316802ed"
import script from "./ChainList.vue?vue&type=script&lang=js"
export * from "./ChainList.vue?vue&type=script&lang=js"
import style0 from "./ChainList.vue?vue&type=style&index=0&id=316802ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports